export const careersEn = {
  hero: {
    title: 'Join Our Team',
    subtitle:
      'Become part of our passionate family and share the love for authentic Italian cuisine',
  },
  whyJoin: {
    title: 'Why Join Rossopomodoro',
    subtitle:
      'Working with us means being part of a passionate team dedicated to authentic Italian cuisine.',
    benefits: [
      {
        title: 'Career Growth',
        description:
          "We invest in our team members' development through training and advancement opportunities.",
      },
      {
        title: 'Team Culture',
        description:
          "Experience a collaborative, supportive environment where everyone's contribution is valued.",
      },
      {
        title: 'Culinary Excellence',
        description:
          'Work with premium ingredients and learn authentic Italian techniques from experienced chefs.',
      },
      {
        title: 'Benefits',
        description:
          'Competitive salary, staff meals, and opportunities for professional development.',
      },
    ],
  },
  application: {
    title: 'Apply to Join Our Team',
    subtitle: "We're always looking for passionate individuals to join our family",
    joinFamily: 'Join Our Family',
    joinFamilyDescription:
      "We're more than colleagues—we're a family united by our passion for Italian cuisine.",
    form: {
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'Email Address',
      phone: 'Phone Number',
      position: 'Position of Interest',
      whyWorkWithUs: 'Why do you want to work with us?',
      resume: 'Resume/CV',
      coverLetter: 'Cover Letter',
      gdprConsent:
        'I consent to the processing of my personal data in accordance with the privacy policy for recruitment purposes',
      submitButton: 'Submit Application',
      submitting: 'Submitting...',
      chooseFile: 'Choose File',
      resumeHelp: 'Upload your resume (PDF, DOC, DOCX - max 5MB)',
      coverLetterHelp: 'Upload your cover letter (PDF, DOC, DOCX - max 2MB)',
      note: "We'll review your application and get back to you within 3-5 business days.",
      successMessage:
        'Your application has been submitted successfully! We will review it and get back to you within 3-5 business days.',
      errorMessage: 'Failed to submit application. Please try again later.',
      placeholders: {
        firstName: 'Your first name',
        lastName: 'Your last name',
        email: 'your.email@example.com',
        phone: '+354 123 4567',
        position: 'Select a position',
        whyWorkWithUs:
          "Tell us why you'd like to work at Rossopomodoro and what makes you a great fit...",
      },
      positions: [
        'Server/Waitress',
        'Kitchen Staff',
        'Pizza Chef',
        'Sous Chef',
        'Manager',
        'Host/Hostess',
        'Bartender',
        'Other',
      ],
      validation: {
        required: 'This field is required',
        emailFormat: 'Please enter a valid email address',
        maxLength: 'Maximum 500 characters allowed',
        fileType: 'Only PDF, DOC, and DOCX files are allowed',
        fileSize: 'File size must be less than {size}',
        resumeRequired: 'Resume is required',
        gdprRequired: 'You must consent to data processing to submit your application',
      },
    },
  },
};
